import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8 10a2.667 2.667 0 0 0 2.667-2.667v-4a2.667 2.667 0 1 0-5.334 0v4A2.667 2.667 0 0 0 8 10M6.667 3.333a1.333 1.333 0 1 1 2.666 0v4a1.333 1.333 0 1 1-2.666 0zm6.666 4a.666.666 0 1 0-1.333 0 4 4 0 0 1-8 0 .667.667 0 1 0-1.333 0 5.33 5.33 0 0 0 4.666 5.287V14H6a.667.667 0 1 0 0 1.333h4A.667.667 0 1 0 10 14H8.667v-1.38a5.334 5.334 0 0 0 4.666-5.287"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })